import basicController from "servicestack/basic.controller.properties";
import ServiceBus from "servicestack/service-bus";

export default class TerritoryParserController {
  constructor(options) {
    console.debug("TerritoryParserController", { that: this, options });
    const $ctrl = this;
    basicController($ctrl);
    $ctrl.selected = {};
    Object.assign($ctrl, options);
    $ctrl.bus = new ServiceBus();
  }

  submit() {
    const $ctrl = this;
      const IdIn = ($ctrl.territoryIds || "NO_TERRITORY_ID").split(/[\s,]+/gi).filter(territoryid => !!territoryid);
    const request = {
      IdIn,
      take: 500,
      fields: "Id"
    };
    $ctrl.bus.send("QueryTerritories.json", request).then(({ data }) => {
      $ctrl.$close(data.results.map(p => p.id));
    });
  }

  $onDestroy() {
    this.bus.dispose();
  }
}
